import React from 'react'

export default function WelcomeLayout(props) {
  return (
    <div  >
    <React.Fragment>{props.children}</React.Fragment>
  </div>
  )
}
